import { DownloadRounded, RefreshRounded, UploadRounded } from "@mui/icons-material";
import { Stack, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { ColDef, ICellRendererParams, IServerSideDatasource, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import dayjs from "dayjs";
import React, { SyntheticEvent, useCallback, useContext, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import { AgGridCustomToolbarProps } from "../../../../../../util/component/AgGridCustomToolbar";
import CustomLoader from "../../../../../../util/component/CustomLoader";
import FileUploader from "../../../../../../util/component/FileUploader";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { downloadTourOperatorFile, downloadTourOperatorLog, getTourOperatorImports, getTourOperatorImportsCount, ITourOperatorImport, uploadTuiFile } from "../../../../api/services";
import updateImportWorkingStatus from "../../../../api/services/updateImportWorkingStatus";
import DialogCloseButton from "../../../../components/DialogCloseButton";
import useDialog from "../../../../hooks/useDialog";
import { ImportWorkingStatus, TourOperatorWorkingStatus } from "../../../../types";
import { createFile } from "../../../../utils";
import { ImportFilterType, JimpiImportTableData, TuiImportTableData } from "../../types";
import TuiFilters from "./tui/TuiFilters";
import TuiTable from "./tui/TuiTable";

export const TuiTabPanel = () => {

    return (
        <>
            <Stack rowGap={3}>
                <TuiFilters />
                <TuiTable />
            </Stack>
        </>
    );
};

export default TuiTabPanel;
